import { useCallback, useState } from 'react';

/**
 * "MOSTRAR O NOME DO ALUNO NOS AVISOS QUE APARECEM NA TELA" (19/10/2026) — desligada por padrão. Fica NESTE APARELHO
 * (o armazenamento do navegador ou do aplicativo), por pessoa, e não no servidor: o risco é do aparelho (o computador
 * ligado ao projetor), e guardar no servidor pediria uma migração. Ler falhando (janela privada, dados apagados) = desligada.
 */
const chave = (userId: string | number) => `portal:notificacoes:nome-no-aviso:${userId}`;

export function nomeNoAvisoLigado(userId: string | number | undefined): boolean {
  if (userId == null) return false;
  try { return localStorage.getItem(chave(userId)) === 'sim'; } catch { return false; }
}

export function useNomeNoAviso(userId: string | number | undefined): [boolean, (v: boolean) => void] {
  const [ligado, setLigado] = useState(() => nomeNoAvisoLigado(userId));
  const mudar = useCallback((v: boolean) => {
    if (userId == null) return;
    try { if (v) localStorage.setItem(chave(userId), 'sim'); else localStorage.removeItem(chave(userId)); } catch { /* sem armazenamento: fica só nesta tela */ }
    setLigado(v);
  }, [userId]);
  return [ligado, mudar];
}
